import { Injectable } from '@angular/core';

@Injectable()
export class LogService {

    debug(logObject?: any): void {
        solid.log.debug(logObject);
    }

    info(logObject?: any): void {
        solid.log.info(logObject);
    }

    warn(logObject?: any): void {
        solid.log.warn(logObject);
    }

    error(logObject?: any): void {
        solid.log.error(logObject);
    }

    fatal(logObject?: any): void {
        solid.log.fatal(logObject);
    }

}